export default __webpack_public_path__ + "1x-mobil-banner.jpg";